// extracted by mini-css-extract-plugin
export default {"button":"Header_button__nfavH","buttonHover":"Header_buttonHover__E-WNG","seperateLine":"Header_seperateLine__ci+XT"};